import { render, staticRenderFns } from "./header-menu.vue?vue&type=template&id=282229ff&scoped=true"
import script from "./header-menu.vue?vue&type=script&lang=js"
export * from "./header-menu.vue?vue&type=script&lang=js"
import style0 from "./header-menu.vue?vue&type=style&index=0&id=282229ff&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282229ff",
  null
  
)

export default component.exports